import React from "react";
import { TrendingUpIcon } from "./Icon";
import styles from "./TrendsButton.module.css";
import AnalyticsManager from "../utils/AnalyticsManager";

interface TrendsButtonProps {
  onClick: () => void;
  isHidden?: boolean;
  isSidebarOpen?: boolean;
  isActive?: boolean;
}

const TrendsButton: React.FC<TrendsButtonProps> = ({
  onClick,
  isHidden = false,
  isSidebarOpen = false,
  isActive = false
}) => {
  const buttonClasses = [
    styles["trends-button"],
    isSidebarOpen ? styles["sidebar-open"] : "",
    isActive ? styles.active : "",
    isHidden ? styles.hidden : ""
  ].filter(Boolean).join(" ");

  return (
    <button
      onClick={() => {
        // Track trends button click
        const analytics = AnalyticsManager.getInstance();
        analytics.trackEvent('trends_button_click', {
          action: isSidebarOpen ? 'close' : 'open',
          event_category: 'trends'
        });
        onClick();
      }}
      className={buttonClasses}
      aria-label="Trending Restaurants"
    >
      <TrendingUpIcon className={styles["trends-icon"]} />
    </button>
  );
};

export default TrendsButton;